module.exports = __webpack_public_path__ + "static/media/eighth_veterans_memorial3.89a9d74d.jpg";